import { FunctionComponent, useEffect, useState } from 'react';
import './ImageRichTextTile.scss';
import { Heading } from '@lmig/lmds-react-typography';
import RichText from './RichText';
import { IconButton, IconTabsCaretLeft, IconTabsCaretRight } from '@lmig/lmds-react-icons';

interface IImageRichTextTile {
  parentfolderid: string;
  backgroundimage: IGlassImage;
  backgroundcolor: string;
  backgroundimageposition: string;
  richtext: string;
  title: string;
  rotating: boolean | string;
  tilesavailable: number;
}

const ImageRichTextTile: FunctionComponent<IImageRichTextTile> = (props: IImageRichTextTile) => {
  const [richTextTile, setRichTextTile] = useState<IImageRichTextTile | undefined>(undefined);
  const [richTextTileKey, setRichTextTileKey] = useState<number>(0);
  const [currentIndex, setCurrentIndex] = useState<number>(0);

  useEffect(() => {
    setRichTextTile({...props, 
                        rotating: props.rotating === "True", 
                        tilesavailable: props.tilesavailable ? parseInt(props.tilesavailable.toString()) : 1});
    setRichTextTileKey((prevKey) => prevKey + 1);
  }, [props]);

  useEffect(() => {
    if (richTextTile && richTextTile.rotating) 
      onTileRefresh(currentIndex);
  }, [currentIndex]);

  const onTileRefresh = async (index: number = 0) => {
    let response = await fetch(`/api/sitecore/PageContentAsync/GetImageRichTextTile`, {
      method: 'POST',
      body: new URLSearchParams({ parentfolderid: richTextTile ? richTextTile.parentfolderid : '', index: index.toString() }),
    });

    if (response.ok) {
      try {
        let data = await response.json();

        if (data?.success && data?.data !== null) {
          let newRichTextTile = {} as IImageRichTextTile;
          newRichTextTile.parentfolderid = data.data.parentFolderId;
          newRichTextTile.backgroundimage = data.data.backgroundImage as IGlassImage;
          newRichTextTile.backgroundimageposition = data.data.backgroundPosition;
          newRichTextTile.richtext = data.data.richText;
          newRichTextTile.title = data.data.title;
          newRichTextTile.rotating = data.data.rotating;
          newRichTextTile.backgroundcolor = data.data.backgroundColor;
          newRichTextTile.tilesavailable = data.data.tilesAvailable;
          setRichTextTile(newRichTextTile);
          setRichTextTileKey((prevKey) => prevKey + 1);
        } else {
          console.log(`Failed Call to GetImageRichTextTile
            \nstatusCode: ${data?.statusCode}
            \nerror: ${data?.error}`);
        }
      } catch (err: any) {
        console.log(`ERROR in GetImageRichTextTile:
          \n${err}
          \n${err.message}`);
      }
    }
  };

  return (
    <>
      <div className={'image-rich-text-tile-wrapper'} key={richTextTileKey}>
        {richTextTile ? (
          <div
            className={'image-rich-text-tile'}
            style={{
              backgroundImage: richTextTile.backgroundimage?.Src ? `url("${richTextTile.backgroundimage.Src}")` : "none",
              backgroundPosition: `${richTextTile.backgroundimageposition || 'center'}`,
              backgroundSize: 'cover',
              backgroundColor:`${richTextTile?.backgroundcolor ? richTextTile.backgroundcolor : 'transparent'}`
            }}
          >
            {richTextTile.title && richTextTile.title.length > 0 ? (
              <div className={'image-rich-text-tile-header'}>
                <div className={'image-rich-text-tile-header-title-container'}>
                  <Heading className="custom-tile-heading-margin" type="h4-light">
                    {richTextTile.title}
                  </Heading>
                </div>
              </div>
            ) : null}
            <div className={'image-rich-text-tile-body'}>
              {richTextTile.rotating && richTextTile.tilesavailable > 1 ? (
              <IconButton className="irt-rotate-left" background="onAtmo" initialSize="16"><IconTabsCaretLeft size="16" onClick={() => setCurrentIndex((currentIndex - 1 + richTextTile.tilesavailable) % richTextTile.tilesavailable)} /></IconButton>
            ) : null}
              <RichText
                className="image-rich-text-full-width"
                content={richTextTile.richtext}
                onTileRefresh={onTileRefresh}
              />
              {richTextTile.rotating && richTextTile.tilesavailable > 1 ? (
              <IconButton className="irt-rotate-right" background="onAtmo" initialSize="16"><IconTabsCaretRight size="16" onClick={() => setCurrentIndex((currentIndex + 1) % richTextTile.tilesavailable)} /></IconButton>
            ) : null}
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
    </>
  );
};

export default ImageRichTextTile;
